import { useSelector } from "react-redux";
import { RootState } from "../../store";

export const useClaimContactData = () => {
    const customerCareData = useSelector(
        (state: RootState) => state.customerCare.customerCareData
    );

    const hasData = () => {
        if (!customerCareData) return false;

        const hasName =
            customerCareData.name && customerCareData.name.trim() !== "";
        const hasPhone =
            customerCareData.phone && customerCareData.phone.trim() !== "";
        const hasEmail =
            customerCareData.email && customerCareData.email.trim() !== "";

        // Check for new detailedEscalationMatrixDTOS structure
        const hasDetailedEscalationMatrix =
            customerCareData.detailedEscalationMatrixDTOS &&
            Object.values(customerCareData.detailedEscalationMatrixDTOS).some(
                (category: any) =>
                    Array.isArray(category) &&
                    category.some(
                        (contact: any) =>
                            contact.name && contact.name.trim() !== ""
                    )
            );

        // Fallback to old escalationMatrixDTOS structure for backward compatibility
        const hasEscalationMatrix =
            customerCareData.escalationMatrixDTOS &&
            customerCareData.escalationMatrixDTOS.length > 0;

        return (
            hasName ||
            hasPhone ||
            hasEmail ||
            hasDetailedEscalationMatrix ||
            hasEscalationMatrix
        );
    };

    return { hasData: hasData(), customerCareData };
};
